module.exports = __webpack_public_path__ + "img/video_bg.a6622764.png";